"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css = require("@emotion/css");
var _expander = _interopRequireDefault(require("@amzn/meridian-tokens/component/expander"));
var _chevronRightSmall = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/chevron-right-small"));
var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));
var _theme = require("../theme");
var _clickable = _interopRequireDefault(require("../_clickable"));
var _icon = _interopRequireDefault(require("../icon"));
var _expanderController = _interopRequireDefault(require("../_expander-controller"));
var _useFocus2 = _interopRequireDefault(require("../_use-focus"));
var _focusRing = _interopRequireDefault(require("./../_styles/focus-ring"));
var _token = require("./../_utils/token");
var _functional = require("./../_utils/functional");
var _text = _interopRequireDefault(require("./../_styles/text"));
var _cxMemoized = _interopRequireDefault(require("./../_utils/cx-memoized"));
var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));
var _reducedMotionStyles = _interopRequireDefault(require("./../_styles/reduced-motion-styles"));
var _propTypes2 = _interopRequireDefault(require("./../_prop-types"));
var _getInlinePadding = _interopRequireDefault(require("./../_utils/get-inline-padding"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var type = _ref.type;
  return (0, _css.css)((0, _text["default"])(t), {
    position: "relative",
    borderBottom: type === "section" ? t.borderCss("border") : undefined,
    border: type === "box" ? t.borderCss("border") : undefined,
    borderRadius: t("borderRadius", type),
    backgroundColor: t("backgroundColor", type)
  });
}, ["type"]);
var iconStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var _objectSpread2;
  var open = _ref2.open;
  return (0, _css.css)(_objectSpread((_objectSpread2 = {
    marginInlineEnd: t("spacingHorizontal"),
    transform: "rotate(".concat(open ? 90 : 0, "deg)")
  }, (0, _defineProperty2["default"])(_objectSpread2, "[dir=\"rtl\"] &", {
    transform: "rotate(".concat(open ? -90 : 0, "deg)")
  }), (0, _defineProperty2["default"])(_objectSpread2, "transition", "transform ".concat(t("iconMotionDuration"), " ").concat(t("iconMotionFunction"))), _objectSpread2), _reducedMotionStyles["default"]));
}, ["open"]);
var handleStyles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var _objectSpread3;
  var type = _ref3.type,
    focus = _ref3.focus;
  var colorType = type === "section" || type === "list" ? "default" : "accent";
  var spacingV = t("spacingVertical");
  var spacingH = t("spacingHorizontal");
  var colorStyles = {
    color: t("foregroundColor", [colorType, "default"]),
    ":hover": {
      color: t("foregroundColor", [colorType, "hover"])
    },
    ":active": {
      color: t("foregroundColor", [colorType, "pressed"])
    }
  };
  return (0, _css.css)(_objectSpread(_objectSpread({
    // Make the whole width of the expander clickable for block-level expanders,
    // otherwise only make the visible content clickable
    display: type === "box" || type === "section" ? "flex" : "inline-flex",
    flexDirection: "row",
    alignItems: "center"
  }, colorStyles), {}, (_objectSpread3 = {
    padding: type === "box" ? "".concat(spacingV, "px ").concat(spacingH, "px") : type === "section" ? "".concat(spacingV, "px ").concat(spacingH, "px ").concat(spacingV, "px 0") : "".concat(spacingV, "px 0")
  }, (0, _defineProperty2["default"])(_objectSpread3, "[dir=\"rtl\"] &", {
    padding: type === "box" ? "".concat(spacingV, "px ").concat(spacingH, "px") : type === "section" ? "".concat(spacingV, "px 0 ").concat(spacingV, "px ").concat(spacingH, "px") : "".concat(spacingV, "px 0")
  }), (0, _defineProperty2["default"])(_objectSpread3, "& > [mdn-expander-title] > *", colorStyles), _objectSpread3)), (0, _focusRing["default"])(t.tokens, {
    focus: focus,
    offset: "0",
    borderRadius: t("borderRadius", type)
  }));
}, ["type", "focus"]);
var childrenStyles = (0, _token.memoizeTokenStyles)(function (t, _ref4) {
  var type = _ref4.type,
    open = _ref4.open,
    spacingInset = _ref4.spacingInset;
  var spacingV = t("spacingVertical");
  var spacingH = t("spacingHorizontal");
  var spacingEnd = type === "section" || type === "box" ? spacingH : 0;
  var spacingStart = spacingH * (type === "box" ? 2 : 1) + _icon["default"].sizes.small;

  // Use default padding so line content up with
  // the expander label when no `spacingInset` is provided
  var padding = spacingInset ? (0, _getInlinePadding["default"])(spacingInset) : {
    paddingTop: 0,
    paddingBottom: "".concat(spacingV, "px"),
    paddingInlineStart: "".concat(spacingStart, "px"),
    paddingInlineEnd: "".concat(spacingEnd, "px")
  };
  return (0, _css.css)(_objectSpread({
    boxSizing: "border-box",
    opacity: open ? 1 : 0,
    transition: "opacity ".concat(t("contentMotionDuration"), " ").concat(t("contentMotionFunction"))
  }, padding));
}, ["type", "open", "spacingInset"]);
var titleStyles = (0, _functional.memoize)(function (type) {
  return type === "box" || type === "section" ? (0, _css.css)({
    flex: "auto"
  }) : undefined;
});
function Expander(props) {
  var title = props.title,
    children = props.children,
    open = props.open,
    id = props.id,
    type = props.type,
    alwaysRenderChildren = props.alwaysRenderChildren,
    onChange = props.onChange,
    spacingInset = props.spacingInset;
  var t = (0, _theme.useTheme)(_expander["default"], "expander");
  var expandableId = (0, _react.useMemo)(function () {
    return (0, _uniqueId["default"])("expandable-");
  }, []);
  var handleOnChange = (0, _react.useCallback)(function () {
    onChange(!open);
  }, [open, onChange]);
  var _useFocus = (0, _useFocus2["default"])(),
    focus = _useFocus.focus,
    focusTrigger = _useFocus.focusTrigger,
    focusProps = _useFocus.focusProps;
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, {
      type: type
    })
  }, /*#__PURE__*/_react["default"].createElement(_clickable["default"], (0, _extends2["default"])({}, focusProps, {
    tag: "div",
    id: id,
    onClick: handleOnChange,
    "aria-expanded": open,
    "aria-controls": expandableId,
    className: handleStyles(t, {
      type: type,
      focus: focus && focusTrigger === "keyboard"
    })
  }, passThroughProps), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _chevronRightSmall["default"],
    open: open,
    className: iconStyles(t, {
      open: open
    })
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: titleStyles(type),
    "mdn-expander-title": ""
  }, title)), /*#__PURE__*/_react["default"].createElement(_expanderController["default"], {
    open: open,
    direction: "down",
    motionDuration: parseInt(t("contentMotionDuration")),
    motionDelay: t("contentMotionDelay"),
    motionFunction: t("contentMotionFunction"),
    alwaysRenderChildren: alwaysRenderChildren
  }, function (_ref5) {
    var containerProps = _ref5.containerProps,
      contentProps = _ref5.contentProps;
    return /*#__PURE__*/_react["default"].createElement("div", containerProps, /*#__PURE__*/_react["default"].createElement("div", {
      id: expandableId,
      ref: contentProps.ref,
      className: (0, _cxMemoized["default"])(contentProps.className, childrenStyles(t, {
        type: type,
        open: open,
        spacingInset: spacingInset
      }))
    }, children));
  }));
}
Expander.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The contents of the expander. Any elements are acceptable.
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * The state of the expander. If true the expander will be open, otherwise it
   * will be closed.
   */
  open: _propTypes["default"].bool.isRequired,
  /**
   * The contents of the expander's clickable header.
   *
   * A plain string is recommended, although any static (non-interactive)
   * elements are allowed. Interactive elements are not allowed as they would
   * interfere with the built-in interactive behavior of the title.
   */
  title: _propTypes["default"].node.isRequired,
  /**
   * A function that will be called when the user attempts to open or close the
   * expander (e.g. by clicking on the title). A boolean representing the new
   * open state of the expander will be passed as the first argument to this
   * function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `open` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,
  /**
   * Normally children of the expander will not be mounted/rendered when the
   * expander is closed. Set this to `true` if the children should be rendered
   * behind the scenes even when the expander is closed and the children are not
   * visible. This is helpful if the children have local state that should be
   * preserved when the expander is closed. In most other cases this prop should
   * be left off to avoid the performance penalty of rendering UI that is not
   * visible to the user.
   */
  alwaysRenderChildren: _propTypes["default"].bool,
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Expander component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following properties,
   * they'll be ignored:
   *
   * aria-controls |  aria-expanded
   */
  "aria-*": _propTypes["default"].string,
  /**
   * All props prefaced with `data-` are accepted. This is useful for adding selectors
   * for integrating with other libraries such as Amplify Analytics or Cypress
   */
  "data-*": _propTypes["default"].string,
  /**
   * Sets an `id` attribute on the component's outer DOM element.
   *
   * Use this for testing, for accessibility, or to target custom elements
   * inside the component. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,
  /**
   * Apply padding around the children content in the Expander.
   *
   * CSS-style [1-to-4 value shorthand](https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties)
   * is accepted (e.g. `"100 none none none"` for 2px
   * padding on the top and 0px padding on the end, bottom, and starting sides).
   *
   * For more information on available spacing tokens please visit the
   * [Spacing fundamentals page](https://meridian.a2z.com/fundamentals/spacing/).
   *
   */
  spacingInset: _propTypes2["default"].spacing(4),
  /**
   * The type of expander. See the expander design guidelines for details.
   */
  type: _propTypes["default"].oneOf(["section", "inline", "list", "box"])
} : {};
Expander.defaultProps = {
  type: "section",
  open: false
};
var _default = Expander;
exports["default"] = _default;